/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Accreditation_RejectInputs */

const en_welcome_accreditation_reject = /** @type {(inputs: Welcome_Accreditation_RejectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` I <b>do not</b> currently meet at least one of the requirements of an accredited investor`)
};

/**
* | output |
* | --- |
* | "I <b>do not</b> currently meet at least one of the requirements of an accredited investor" |
*
* @param {Welcome_Accreditation_RejectInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const welcome_accreditation_reject = /** @type {((inputs?: Welcome_Accreditation_RejectInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Accreditation_RejectInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_welcome_accreditation_reject(inputs)
});